import {observer} from "mobx-react-lite";
import ConnectionStatus from "../ConnectionStatus/ConnectionStatus";
import React from "react";
import styled from "styled-components";
import {ModeSelector} from "./ModeSelector";
import {EasyMode} from "../ui/Stepper"; // TODO: remove this        
import {ProMode} from "./ProMode";
import ConfigStore from "../../store/config-store";
import {IosLoader} from "../Loaders/IosLaoder/IosLoader";

const Container = styled.div`
    width: 100%;
    padding: 40px 16px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
const modes = [
    {
        name: "easy",
        title: "Easy",
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
            >
                <g clipPath="url(#clip0_1815_41726)">
                    <path
                        d="M14.5139 15.0962C14.8491 15.4406 15.4356 15.4313 15.7521 15.0962C16.0873 14.7424 16.078 14.1931 15.7521 13.8486L8.85358 6.93149C8.51843 6.58703 7.93191 6.58703 7.61537 6.93149C7.28022 7.28526 7.28955 7.83455 7.61537 8.1697L14.5139 15.0962ZM14.8025 14.5376L10.3525 10.0875L10.7435 9.7058L15.1935 14.1559C15.3332 14.2955 15.3704 14.4538 15.2401 14.5934C15.1004 14.7145 14.9515 14.6865 14.8025 14.5376Z"
                        fill="white"
                        fillOpacity="0.75"
                    />
                    <path
                        d="M5.61379 15.3848C5.77206 15.3848 5.87447 15.2824 5.89308 15.1241C6.11651 13.169 6.23755 13.0946 8.21121 12.7967C8.38811 12.7687 8.49981 12.6756 8.49981 12.5174C8.49981 12.3591 8.38811 12.266 8.24846 12.2381C6.25616 11.8657 6.11651 11.8564 5.89308 9.91061C5.87447 9.75236 5.77206 9.64063 5.61379 9.64063C5.46483 9.64063 5.35311 9.75236 5.33451 9.90131C5.10176 11.8843 5.00866 11.9774 2.98844 12.2381C2.83948 12.2567 2.73707 12.3591 2.73707 12.5174C2.73707 12.6663 2.83948 12.7687 2.98844 12.7967C5.00866 13.1783 5.09244 13.1877 5.33451 15.1334C5.35311 15.2824 5.46483 15.3848 5.61379 15.3848ZM2.15055 8.97964C2.27158 8.97964 2.33675 8.90516 2.35538 8.79345C2.60673 7.35974 2.60673 7.28526 4.11492 7.03389C4.22663 7.01528 4.30111 6.95011 4.30111 6.82908C4.30111 6.70806 4.22663 6.6429 4.11492 6.62427C2.60673 6.3729 2.60673 6.29842 2.35538 4.86472C2.33675 4.75301 2.27158 4.67852 2.15055 4.67852C2.03884 4.67852 1.96437 4.75301 1.94574 4.86472C1.70369 6.29842 1.70369 6.3729 0.186195 6.62427C0.0837874 6.6429 0 6.70806 0 6.82908C0 6.95011 0.0837874 7.01528 0.186195 7.03389C1.70369 7.28526 1.70369 7.35974 1.94574 8.79345C1.96437 8.90516 2.03884 8.97964 2.15055 8.97964ZM6.20962 4.23166C6.31202 4.23166 6.35856 4.16649 6.37719 4.0827C6.61924 2.89105 6.60063 2.87244 7.83882 2.62107C7.93192 2.60246 7.99709 2.54659 7.99709 2.45349C7.99709 2.35109 7.93192 2.29522 7.83882 2.27661C6.60063 2.02524 6.61924 2.01594 6.37719 0.814982C6.35856 0.731185 6.31202 0.666016 6.20962 0.666016C6.11651 0.666016 6.06065 0.731185 6.04204 0.814982C5.79999 2.01594 5.8186 2.02524 4.58041 2.27661C4.48731 2.29522 4.43145 2.35109 4.43145 2.45349C4.43145 2.54659 4.48731 2.60246 4.58041 2.62107C5.8186 2.87244 5.79999 2.89105 6.04204 4.0827C6.06065 4.16649 6.11651 4.23166 6.20962 4.23166ZM12.3261 6.86632C12.4378 6.86632 12.5123 6.78254 12.531 6.68013C12.773 5.24642 12.7823 5.17194 14.2905 4.92059C14.4022 4.90196 14.4767 4.82749 14.4767 4.71576C14.4767 4.59474 14.4022 4.52958 14.2905 4.51095C12.7823 4.25959 12.773 4.1851 12.531 2.7514C12.5123 2.63969 12.4378 2.5652 12.3261 2.5652C12.2144 2.5652 12.1399 2.63969 12.1213 2.7514C11.8793 4.1851 11.87 4.25959 10.3618 4.51095C10.2501 4.52958 10.1756 4.59474 10.1756 4.71576C10.1756 4.82749 10.2501 4.90196 10.3618 4.92059C11.87 5.17194 11.8793 5.24642 12.1213 6.68013C12.1399 6.78254 12.2144 6.86632 12.3261 6.86632Z"
                        fill="white"
                        fillOpacity="0.75"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1815_41726">
                        <rect width="16" height="16" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
        ),
        description: "Используйте клиент DeGuard",
    },
    {
        name: "pro",
        title: "Pro",
        icon: (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.19995 9.97186C3.19995 10.3262 3.48342 10.5894 3.84786 10.5894H8.31239L5.96369 16.9673C5.62962 17.8886 6.58125 18.3846 7.18865 17.6355L14.4271 8.59505C14.5688 8.40271 14.6498 8.23061 14.6498 8.02812C14.6498 7.67379 14.3764 7.41059 14.0019 7.41059H9.53735L11.886 1.03269C12.2302 0.111432 11.2685 -0.384611 10.6611 0.364522L3.42267 9.40494C3.28094 9.5973 3.19995 9.7694 3.19995 9.97186Z"
                    fill="white"
                />
            </svg>
        ),
        description: "Генерация конфигураций",
    },
];

export const VPN = observer(({servers}) => {
    let activeMode = ConfigStore.activeMode;
    if (!servers) return (
        <div style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
            <IosLoader/>
        </div>);


    return (
        <>
            {/*<ConfigsLoadingScreen/>*/}
            <Container>
                <ConnectionStatus/>
                <ModeSelector
                    activeMode={activeMode}
                    setActiveMode={ConfigStore.setActiveMode}
                    modes={modes}
                />
                {activeMode === "pro" ? <ProMode servers={servers}/> : <EasyMode/>}
            </Container>
        </>
    );
});